<div class="card-body">
    <div id="apex-mixed-charts-line-column"></div>
</div>